import React from 'react';
import { Col } from 'antd';
import {
  OrganizationBusinessType,
  OrganizationUnitType,
} from '@institutions/graphql';
import { Gutter, Title, Text, Collapse } from '@common/components';

export function SupplierDetailsSummaryUnits({
  title,
  units,
}: {
  title: string;
  units?: OrganizationUnitType[];
}) {
  const organizationBusinessesFromUnits = Object.values(
    groupByOrganizationBusiness(units)
  );

  if (!units?.length || !organizationBusinessesFromUnits.length) {
    return null;
  }

  return (
    <Col>
      <Gutter size="lg" direction="bottom">
        <Gutter size="md" direction="bottom">
          <Title size="h3" weight="medium">
            {title} ({units.length})
          </Title>
        </Gutter>
        <Collapse accordion>
          {organizationBusinessesFromUnits.map(({ business, units }) => (
            <Collapse.Panel
              key={business.id}
              header={
                <Text size="lg" weight="medium" color="elm">
                  {business.name} ({units.length})
                </Text>
              }
            >
              <ul>
                {units.map((unit) => (
                  <li key={unit.id}>{unit.name}</li>
                ))}
              </ul>
            </Collapse.Panel>
          ))}
        </Collapse>
      </Gutter>
    </Col>
  );
}

type OrganizationBusinessFromUnitsType = {
  business: OrganizationBusinessType;
  units: OrganizationUnitType[];
};

function groupByOrganizationBusiness(
  organizationUnits?: OrganizationUnitType[]
) {
  const organizationBusinesses: Record<
    string,
    OrganizationBusinessFromUnitsType
  > = {};

  organizationUnits?.forEach((unit) => {
    const { organizationBusiness } = unit.department;

    if (!organizationBusinesses[organizationBusiness.id]) {
      organizationBusinesses[organizationBusiness.id] = {
        business: organizationBusiness,
        units: [],
      };
    }

    organizationBusinesses[organizationBusiness.id].units.push(unit);
  });

  return organizationBusinesses;
}
